/**
 * Feature flags for incrementally-shipped functionality.
 *
 * Flags ship disabled and are flipped on once their backing dependencies land.
 * Prefer plain module-level constants; use an `import.meta.env.VITE_*` flag when
 * a feature needs to be live on one environment and off on another. Vite
 * statically replaces those at build time, so both forms stay tree-shakeable.
 */

/**
 * Contact Discovery (Contact Enrichment epic TD-2072, Stream B).
 *
 * Gates the "Discover contacts" panel in the Key Contacts tab. Enabled now that
 * the discover BE (TD-2083 / TD-2104 / TD-2272) is deployed on DEV and the FE is
 * wired to it (discover + persist-on-reveal via /enrichment/discover-reveal).
 */
export const STREAM_B_ENABLED = true;

/**
 * Contact Enrichment & Discovery in the AI agent (TD-2280 / TD-2293).
 *
 * Gates the agent-chat enrichment surface: the reveal-options / choose-roles
 * bars, discovery results, and the confirm-before-spend reveal handshake. While
 * off, enrichment tags are still stripped from chat text (no leakage) but
 * nothing renders.
 *
 * Per-environment because the reveal handshake SPENDS enrichment credits: on
 * dev, where the agent tag emission is live (TD-2281 reveal, TD-2713 discovery)
 * and it can be exercised end to end; off on stg/prod until that passes.
 *
 * Two surfaces stay dormant even when enabled, for want of a consumer rather
 * than a flag: the discovery card (TD-2755 — the tag is emitted and parsed, but
 * `AgentEnrichmentCards` has no discovery branch) and the numbered-options bar
 * (TD-2362 — the agent does not emit `[AGENT_OPTIONS]` at all).
 */
export const AGENT_ENRICHMENT_ENABLED =
  import.meta.env.VITE_AGENT_ENRICHMENT_ENABLED === 'true';
